import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { useI18n } from '../../i18n';
import { STATUS_PAGE_URL } from '../../app/status-page';
import { LEGAL, copyrightYears } from './legal';

/**
 * "© 2026 Ivars Miezis. All rights reserved.", the legal pages and the status page: under sign-in, in the menu, on these pages.
 * In the menu, also the build DoCuLat runs (TF-387), so a question to support can say which.
 */
export function LegalFooter({ showVersion = false }: { showVersion?: boolean }) {
  const { t } = useI18n();
  return (
    <footer className="legal-footer small muted">
      <span>{t('legal.rights', { years: copyrightYears(), holder: LEGAL.holder })}</span>
      <Link to="/legal/terms">{t('legal.terms')}</Link>
      <Link to="/privacy">{t('legal.privacy')}</Link>
      <Link to="/copyright">{t('legal.copyright')}</Link>
      <Link to="/legal/dpa">{t('legal.dpa')}</Link>
      {/* Is DoCuLat up? The status page, which answers when DoCuLat does not (TF-133). */}
      <a href={STATUS_PAGE_URL} target="_blank" rel="noopener">
        {t('status.link')}
      </a>
      {showVersion && <BuildVersion />}
    </footer>
  );
}

/** "Version main-3c7f163", from /version; nothing while it loads or when it cannot be read. */
function BuildVersion() {
  const { t } = useI18n();
  const build = useQuery({
    queryKey: ['version'],
    queryFn: async () => {
      const response = await fetch('/version');
      if (!response.ok) throw new Error(String(response.status));
      return (await response.json()) as { version: string; commit: string | null };
    },
    // A deploy reloads nobody's page; a quarter of an hour is soon enough to show the new build.
    staleTime: 15 * 60_000,
    retry: false,
  });
  if (!build.data?.version) return null;
  return <span title={build.data.commit ?? undefined}>{t('status.version', { version: build.data.version })}</span>;
}
